import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./style.scss";
import Dropdown from "../../../dropdown/index.js";
import { useState } from "react";
import { getAllSchemeDetails, getFundDetails, saveKycDataEcart } from "../action";
import { updateEcartDetails } from "../../../../../actions";
import {
  encryptAES,
  cleanAuthContent,
} from "../../Authentication/action";
import TransactionCard from "./TransactionCard";
import { MODALS } from "../../../../general/Modal/constants";
import { closePopup, openPopup } from "../../../../general/Modal/action";
import cookie from "react-cookies";
import moment from "moment";
import { round } from "lodash";
import { toast } from "react-toastify";

const CartDetails = (props) => {
  const {
    openPopup,
    closePopup,
    eCart,
    getFundDetails,
    getAllSchemeDetails,
    setCartJourneyPage,
    returnValue,
    fundData,
    updateEcartDetails,
    InvestNow,
    saveKycDataEcart,
    // popupData,
    // handlepopupshow,
    // handlepopupClose,
    isJanNivesh,
  } = props;

  const [amount, setAmount] = useState({
    sipAmount: "",
    purchaseAmount: "",
  });
  const [showAddButton, setShowAddButton] = useState({
    type: "",
    show: false,
  });

  const [transactionDetails, setTransactionDetails] = useState({});
  const [transactionMonth, setTransactionMonth] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endDateErr, setEndDateErr] = useState(false);
  const [error, setError] = useState({
    sipError: "",
    purchaseError: "",
  });
  const [schemeList, setSchemeList] = useState([]);
  const [selectedScheme, setSelectedScheme] = useState({
    name: "",
    code: "",
    monMax: "",
  });

  const [IDCWOptions, setIDCWOptions] = useState([]);
  const [schemIsDividend, setSchemeIsDividend] = useState(false);
  const [selectedIDCW, setSelectedIDCW] = useState(null);
  const [fundDetailsData, setFundDetailsData] = useState({});
  const [cancellationIsChecked, setCancellationIsChecked] = useState(false);
  const [sipTDate, setSipTDate] = useState(null);
  const [firstLoad, setfirstLoad] = useState(true);
  const [secondLoad, setsecondLoad] = useState(true);
  const [showError, setShowError] = useState({
    show: false,
    type: "",
  });
  const [emandateTxt, setemandateTxt] = useState(true);
  const [filterMonMaxInstallmentNumber, setFilterMonMaxInstallmentNumber] = useState();
  const[clear, setClear]= useState(false);
  const [dividendOptionValue, setdividendOptionValue] = useState("Growth");
  const [addYearDate, setAddYearDate] = useState();
  const [janNiveshRuleData, setJanNiveshRuleData] = useState();

  const onAddToCart = () => {
    // let sipStartDate = startDate.substring(0, startDate.indexOf('T'));
    // let isFundExistInCookie = cartDetailCookie[fundData?.id];
    let cartDetailCookie = cookie.load("CartDetails") || {}; //get cookie
    setClear(true);
    // add & edit from cookie by pranov mundhada
    let checkIndex = -1;
    if (fundData.isEditFlow) {
      for (const key in cartDetailCookie) {
        if (cartDetailCookie[key].id === fundData?.id) {
          checkIndex = key;
          break;
        }
      }
    }
    let cookieId = 0;
    if (checkIndex !== -1) {
      cookieId = checkIndex;
    } else {
      cookieId = Object.values(cartDetailCookie).length;
    }

    let isDirectOrRegular = checkIsDirectOrRegular(
      eCart.allSchemeDetails?.data?.funds,
      fundData?.fundCode,
      selectedScheme?.code
    );

    let cookieData = {
      fundName: fundData?.fundName,
      fundCode: fundData?.fundCode,
      scheme: {
        name: selectedScheme.name,
        code: selectedScheme.code,
      },
      purchaseAmount: amount.purchaseAmount ? amount.purchaseAmount : null,
      sipAmount: amount.sipAmount ? amount.sipAmount : null,
      idcwOptions: IDCWOptions,
      selectedIDCW: selectedIDCW,
      sipOpted: amount?.sipAmount ? true : false,
      purchaseOpted: amount?.purchaseAmount ? true : false,
      sipDate: startDate,
      toDate: endDate,
      ...fundDetailsData,
      errorExists: false,
      frequency: "OM",
      id: fundData.id ? fundData.id : round(Math.random() * 10000, 0),
      ...isDirectOrRegular,
      cancellationIsChecked,
    };

    let cartData = Object.values(cartDetailCookie);
    if (
      (cartData?.length &&
        cartData[0]?.isRegular &&
        isDirectOrRegular.isDirect) ||
      (cartData.length && cartData[0]?.isDirect && isDirectOrRegular?.isRegular)
    ) {
      setShowError({
        show: true,
        type: "directRegular",
      });

      let cookieMsg = ''
      if (cartData.length > 0 && Object.values(cartData)[0].isDirect) {
        cookieMsg = 'Direct';
      } else {
        cookieMsg = 'Regular';
      }
      toast.error(`You have added ${cookieMsg} Scheme. Kindly select same scheme plan.`);
      // You have added ${Object.values(
      //   cookie.load("CartDetails").length > 0 &&
      //     Object.values(cookie.load("CartDetails"))[0].isDirect
      //     ? "Direct Scheme"
      //     : "Regular Scheme"
      // )}. Kindly select same scheme plan`
      return;
    }

    if (Object.values(cartDetailCookie).length < 3) {
      let isCGF = checkIsCGF();
      let isRetirement = checkIsRetirement();

      if (Object.values(cartDetailCookie).length !== 0) {
        if (
          (isCGF && transactionDetails.retirementApplicable) ||
          (isRetirement && transactionDetails.cgfApplicable)
        ) {
          setShowError({
            show: true,
            type: "cgf",
          });
          toast.error("Children's Gift Fund & Retirement cannot be added together.")
        } else {
          cartDetailCookie[cookieId] = cookieData;
          cookie.save("CartDetails", cartDetailCookie, { path: "/" });
          setCartJourneyPage(1);
          openToast();
        }
      } else {
        cartDetailCookie[cookieId] = cookieData;
        cookie.save("CartDetails", cartDetailCookie, { path: "/" });
        setCartJourneyPage(1);
        openToast();
      }
      updateEcartDetails(cartDetailCookie);
    } else if (
      Object.values(cartDetailCookie).length === 3 &&
      fundData.isEditFlow
    ) {
      cartDetailCookie[cookieId] = cookieData;
      cookie.save("CartDetails", cartDetailCookie, { path: "/" });
      setCartJourneyPage(1);
      updateEcartDetails(cartDetailCookie);
      openToast();
    } else {
      setShowError({
        show: true,
        type: "maxLimit",
      });
      toast.error("Maximum items added in the cart.")
    }
  };
  const [authvalues, setAuthvalues] = useState({
    pan: "",
    dob: "",
    mobile: "",
    email: "",
  });

  useEffect(()=>{
    const addYear = eCart.fundDetails?.data?.sipSettings?.upi?.maxMandateDurationYears;
    setAddYearDate(addYear)
  },[eCart])

  useEffect(() => {
    if (authvalues.pan && authvalues.dob) {
      let object = {
        pan: authvalues.pan,
        dob: moment(authvalues.dob).format("DD-MMM-YYYY"),
        email: authvalues.email,
        mobile: authvalues.mobile,
      };
      setRedirectionLink(encryptAES(JSON.stringify(object)));
    }
  }, [authvalues]);

  const onSubmit = async (authValues, kycData) => {
    setAuthvalues((currentValue) => ({
      ...currentValue,
      pan: authValues.pan,
      dob: authValues.dob,
      mobile: authValues.mobile,
      email: authValues.email,
    }));
    if (kycData && kycData.data && kycData.data.kycVerifiedFlag) {
      let objectt = {
        pan: authValues.pan,
        dob: moment(authValues.dob).format("DD-MMM-YYYY"),
        email: authValues.email,
        mobile: authValues.mobile,
      };
      let modalData = {
        closeAction: closePopup,
        verifyOtpData: {
          kycData,
          objectt,
        },
        objectt,
        joruneyPage: 6,
        modalClass: "ecart-modal-folio",
      };
      openPopup(MODALS.ECART_MODAL, modalData);
    } else {
      let objectt = encryptAES(JSON.stringify({
        pan: authValues.pan,
        dob: moment(authValues.dob).format("DD-MMM-YYYY"),
        email: authValues.email,
        mobile: authValues.mobile,
      }));
      await saveKycDataEcart({
        email: authValues.email,
        mobile: authValues.mobile,
        panNumber: authValues.pan,
        kycStatus: "NOT_VERIFIED",
      });
      let modalData = {
        modalClass: "ecart-modal-ekyc",
        joruneyPage: 5,
        objectt,
      };
      openPopup(MODALS.ECART_MODAL, modalData);
    }
  };

  const onContinueToPay = () => {
    let childrennriFUnd = true;
    let detailsFromCookies =
      (cookie.load("ProceedCartDetails") && cookie.load("ProceedCartDetails")) || {};

    if(detailsFromCookies && Object.values(detailsFromCookies) && Object.values(detailsFromCookies).length > 0){
      Object.values(detailsFromCookies).map((item, index) => {
        if(item.cgfApplicable){
          childrennriFUnd = false;
        }
      })
    }
    
    let modalData = {
      closeAction: cleanAuthContent,
      modalClass: "authentication-modal",
      onSubmit: onSubmit,
      authValues: authvalues,
      childrennriFund: childrennriFUnd
    };
    openPopup(MODALS.AUTHENTICATION, modalData);
    cleanAuthContent();
  };

  const onInvestCart = () => {
    let cartDetailCookie = cookie.load("ProceedCartDetails") || {} ; //get cookie
    let checkIndex = -1;
    if(Object.values(cartDetailCookie).length > 0){
      cookie.remove('ProceedCartDetails', { path: '/' });
      cartDetailCookie = {};
    }
    if (fundData.isEditFlow) {
      for (const key in cartDetailCookie) {
        if (cartDetailCookie[key].id === fundData?.id) {
          checkIndex = key;
          break;
        }
      }
    }

    let cookieId = 0;
    if (checkIndex !== -1) {
      cookieId = checkIndex;
    } else {
      cookieId = Object.values(cartDetailCookie).length;
    }

    let isDirectOrRegular = checkIsDirectOrRegular(
      eCart.allSchemeDetails?.data?.funds,
      fundData?.fundCode,
      selectedScheme?.code
    );

    let cookieData = {
      fundName: fundData?.fundName,
      fundCode: fundData?.fundCode,
      scheme: {
        name: selectedScheme.name,
        code: selectedScheme.code,
      },
      purchaseAmount: amount.purchaseAmount ? amount.purchaseAmount : null,
      sipAmount: amount.sipAmount ? amount.sipAmount : null,
      idcwOptions: IDCWOptions,
      selectedIDCW: selectedIDCW,
      sipOpted: amount?.sipAmount ? true : false,
      purchaseOpted: amount?.purchaseAmount ? true : false,
      sipDate: startDate,
      toDate: endDate,
      ...fundDetailsData,
      errorExists: false,
      frequency: "OM",
      id: fundData.id ? fundData.id : round(Math.random() * 10000, 0),
      ...isDirectOrRegular,
      cancellationIsChecked,
    };

    let cartData = Object.values(cartDetailCookie);
    if (
      (cartData?.length &&
        cartData[0]?.isRegular &&
        isDirectOrRegular.isDirect) ||
      (cartData.length && cartData[0]?.isDirect && isDirectOrRegular?.isRegular)
    ) {
      setShowError({
        show: true,
        type: "directRegular",
      });
      let cookieMsg = ''
      if (cartData.length > 0 && Object.values(cartData)[0].isDirect) {
        cookieMsg = 'Direct';
      } else {
        cookieMsg = 'Regular';
      }
      toast.error(`You have added ${cookieMsg} Scheme. Kindly select same scheme plan.`);
      return;
    }

    cookie.save("ProceedCartDetails", {"0":cookieData}, { path: "/" });

    if (Object.values(cartDetailCookie).length == 1) {
      let isCGF = checkIsCGF();
      let isRetirement = checkIsRetirement();

      if (Object.values(cartDetailCookie).length !== 0) {
        if (
          (isCGF && transactionDetails.retirementApplicable) ||
          (isRetirement && transactionDetails.cgfApplicable)
        ) {
          setShowError({
            show: true,
            type: "cgf",
          });
          toast.error("Children's Gift Fund & Retirement cannot be added together.")
        }
      } 
    }

    onContinueToPay();
  }

  const openToast = () => {
    if (fundData.isEditFlow) {
      toast.success("Selected scheme is successfully edited", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      toast.success("Selected scheme is successfully added to the cart", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const onAmountChange = (val, name) => {
    var val = val.replace(/\,/g, "");
    if (name === "Purchase") {
      setAmount({ ...amount, purchaseAmount: val });
      if (
        transactionDetails.purchaseValidation.minFirstPurchaseAmt &&
        val < transactionDetails.purchaseValidation.minFirstPurchaseAmt
      ) {
        setError({
          ...error,
          purchaseError: `Minimum amount should be ₹ ${transactionDetails.purchaseValidation.minFirstPurchaseAmt}`,
        });
      } else if (
        transactionDetails.purchaseValidation.purchaseMultiple &&
        val % transactionDetails.purchaseValidation.purchaseMultiple !== 0
      ) {
        setError({
          ...error,
          purchaseError: `Please Provide In multiples of ₹ ${transactionDetails.purchaseValidation.purchaseMultiple}`,
        });
      } else setError({ ...error, purchaseError: "" });
    } else if (name === "Sip") {
      setAmount({ ...amount, sipAmount: val });
      if (
        transactionDetails.sipValidation &&
        transactionDetails.sipValidation.additionalValidation &&
        transactionDetails.sipValidation.additionalValidation.OM &&
        transactionDetails.sipValidation.additionalValidation.OM &&
        transactionDetails.sipValidation.additionalValidation.OM[0] &&
        transactionDetails.sipValidation.additionalValidation.OM[0]
          .min_amount_lower &&
        val <
        transactionDetails.sipValidation.additionalValidation.OM[0]
          .min_amount_lower
      ) {
        setError({
          ...error,
          sipError: `Minimum amount should be ₹ ${transactionDetails.sipValidation.additionalValidation.OM[0].min_amount_lower}`,
        });
      } else if (
        transactionDetails.sipValidation &&
        transactionDetails.sipValidation.additionalValidation &&
        transactionDetails.sipValidation.additionalValidation.OM &&
        transactionDetails.sipValidation.additionalValidation.OM &&
        transactionDetails.sipValidation.additionalValidation.OM[0] &&
        transactionDetails.sipValidation.additionalValidation.OM[0]
          .amt_multiples &&
        val %
        transactionDetails.sipValidation.additionalValidation.OM[0]
          .amt_multiples !==
        0
      ) {
        setError({
          ...error,
          sipError: `Please Provide In multiples of ₹ ${transactionDetails.sipValidation.additionalValidation.OM[0].min_amount_lower}`,
        });
      } else if (val > 1999999) {
        setError({
          ...error,
          sipError: `This is a high value registration, we request you to contact (hello@hdfcfund.com) for assistance to complete your registration`,
        });
      } else setError({ ...error, sipError: "" });

      let om =
        transactionDetails.sipValidation &&
        transactionDetails.sipValidation.additionalValidation &&
        transactionDetails.sipValidation.additionalValidation.OM &&
        transactionDetails.sipValidation.additionalValidation.OM.length > 0 &&
        transactionDetails.sipValidation.additionalValidation.OM;
      if (om != undefined && om.length > 0) {
        let filteredObj = om.find((obj, index) => {
          if (obj.min_amount_lower <= val && obj.min_amount_upper >= val) {
            return obj;
          } else if (
            obj.min_amount_upper == undefined &&
            obj.min_amount_lower <= val
          ) {
            return obj;
          }
        });
        if (filteredObj != undefined) {
          setTransactionMonth(filteredObj.min_installments);
        }
      }
    }
  };

  const onRemoveClick = (name) => {
    if (name === "Purchase") {
      setTransactionDetails({
        ...transactionDetails,
        purchaseValidation: null,
      });
      setAmount({
        ...amount,
        purchaseAmount: null,
      });
      setError({ ...error, purchaseError: "" });
    } else if (name === "Sip") {
      setTransactionDetails({ ...transactionDetails, sipValidation: null });
      setAmount({
        ...amount,
        sipAmount: null,
      });
      setError({ ...error, sipError: "" });
    }

    setShowAddButton({
      type: name,
      show: true,
    });
  };

  const d_m_y = (date) => {
    const selectedDate = new Date(date);
    const formattedDate = ("0" + selectedDate.getDate()).slice(-2) + "-" + ("0" + (selectedDate.getMonth() + 1)).slice(-2) + "-" + selectedDate.getFullYear();
    return formattedDate;
  }
  
  const onChange = (name, value) => {
    setEndDateErr(false);
    if (name === "startDate") {
      setStartDate(value);

      if (!cancellationIsChecked) {
        if(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax !== undefined){
          setEndDate();
        }else{
          setEndDate( moment(moment(value), "MM-DD-YYYY").add(addYearDate, "years").subtract(1, "M"));         
        }
      }
      if (cancellationIsChecked) {
        setEndDate(moment(moment(value), "MM-DD-YYYY").set("year", 2099));
      }
    } else if (name === "endDate") {
      setEndDate(value);
      setCancellationIsChecked(false);
      setClear(true);

      let date1 = moment(startDate, 'DD-MM-YYYY');
      let date2 = moment(value, 'DD-MM-YYYY');
      let date3 = moment(startDate, 'DD-MM-YYYY').set("year", 2099);
      const checkDate1 = d_m_y(date2);
      const checkDate2 = d_m_y(date3);

      if (checkDate1 == checkDate2) {
        setCancellationIsChecked(true);
      }

      let differenceMonth = date2. diff(date1, 'months');

      if(differenceMonth > 358){
        setemandateTxt(true);
      }

    }
  };

  const addSipPurchase = (name) => {
    eCart.fundDetails?.data?.schemeDetails.map((ele, index) => {
      if (ele.schemeCode === transactionDetails.schemeCode) {
        if (name === "Purchase") {
          setTransactionDetails({
            ...transactionDetails,
            purchaseValidation:
              eCart.fundDetails.data?.schemeDetails[index].purchaseValidation,
          });

          setAmount({
            ...amount,
            purchaseAmount:
              eCart.fundDetails.data?.schemeDetails[index].purchaseValidation
                .webPurchaseEnabled === "Y"
                ? eCart.fundDetails.data?.schemeDetails[index]
                  .purchaseValidation.defaultAmount
                : null,
          });
        }
        if (name === "Sip") {
          setTransactionDetails({
            ...transactionDetails,
            sipValidation:
              eCart.fundDetails.data?.schemeDetails[index].sipValidation,
          });

          setAmount({
            ...amount,
            sipAmount:
              eCart.fundDetails.data?.schemeDetails[index].sipValidation
                .sipEnabled === "Y"
                ? eCart.fundDetails.data?.schemeDetails[index].sipValidation
                  .sipDefaultAmount
                : null,
          });
        }
      }
    });
    setShowAddButton({
      type: name,
      show: false,
    });
  };

  const onLoad = async () => {
    let response = null;
    response = await getAllSchemeDetails();
    response && fetchFundDetails(response);
  };

  useEffect(() => {
    fundData.fundCode && onLoad();
  }, [fundData.fundCode]);

  useEffect(() => {
    if (schemeList) {
      const filterMonMax = schemeList.find((item) => item.name === selectedScheme.name);
      setFilterMonMaxInstallmentNumber(filterMonMax);
    }
  }, [schemeList, selectedScheme]);
   
  useEffect(() => {
    let aboutFunds =
      eCart.fundDetails.data && eCart.fundDetails.data.schemeDetails;
    let janNiveshRules =
      eCart.fundDetails.data && eCart.fundDetails.data.janNiveshRules;

    if (aboutFunds) {
      let schemes = aboutFunds?.map((ele) => {
        return { name: ele.schemeName, code: ele.schemeCode, monMax: ele.sipValidation.monMaxInstallmentNumber };
      });
      setSchemeList(schemes);

      let growthIndex='';
      aboutFunds?.map((investment,index) => {
        if(investment.investmentOption == "GROWTH"){
          growthIndex = index;
        }
      });
      setSelectedScheme({
        name: fundData?.scheme?.name ? fundData.scheme.name : growthIndex ? schemes[growthIndex]?.name:schemes[0]?.name,
        code: fundData?.scheme?.code ? fundData.scheme.code : growthIndex ? schemes[growthIndex]?.code:schemes[0]?.code,
        monMax: filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax ? filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax : growthIndex ? schemes[growthIndex]?.monMax:schemes[0]?.monMax,
      });
            

      setPreLoginData(
        eCart?.allSchemeDetails?.data?.funds,
        fundData?.scheme?.code ? fundData.scheme.code : schemes[0]?.code
      );

      let options = [];
      aboutFunds?.length > 0 &&
        aboutFunds[0].dividendReinvestmentApplicable &&
        options.push({ name: "Re-investment" });
      aboutFunds?.length > 0 &&
        aboutFunds[0].dividendPayoutApplicable &&
        options.push({ name: "Payout" });
      setIDCWOptions(options);

      if (fundData.isEditFlow && fundData.idcwOptions?.length > 0) {
        setIDCWOptions(fundData.idcwOptions);
        if ((fundData?.scheme?.name).includes('Growth')) {
          setdividendOptionValue("Growth");
        }else{
          setdividendOptionValue(fundData?.selectedIDCW?.name);
        }
      }

      let selectedSchemeData = getSelectedSchemeData(
        aboutFunds,
        fundData?.scheme?.code ? fundData.scheme.code : growthIndex ? schemes[growthIndex]?.code:schemes[0]?.code
      );
      setSchemeIsDividend(selectedSchemeData?.investmentOption === "DIVIDEND");
      setAmount({
        purchaseAmount:
          isJanNivesh ? null :
          fundData?.purchaseAmount || fundData?.purchaseAmount === null
            ? fundData.purchaseAmount
            : selectedSchemeData?.purchaseValidation.webPurchaseEnabled === "Y"
              ? selectedSchemeData?.purchaseValidation.defaultAmount
              : null,
        sipAmount:
          isJanNivesh && janNiveshRules?.sipDefaultAmount ? janNiveshRules?.sipDefaultAmount :
          fundData?.sipAmount || fundData?.sipAmount === null
            ? fundData.sipAmount
            : selectedSchemeData?.sipValidation.sipEnabled === "Y"
              ? selectedSchemeData?.sipValidation.sipDefaultAmount
              : null,
      });
      setSipTDate(selectedSchemeData?.sipValidation?.sipTDate);

      if (fundData?.isEditFlow) {
        setTransactionDetails(() => {
          return {
            purchaseValidation:
              fundData?.purchaseAmount === null
                ? null
                : selectedSchemeData?.purchaseValidation,
            sipValidation:
              fundData?.sipAmount === null
                ? null
                : selectedSchemeData?.sipValidation,
            schemeCode: fundData?.scheme.code,
            fundName: fundData?.scheme.name,
          };
        });

        if (
          (fundData.sipAmount === null &&
            selectedSchemeData?.sipValidation.sipEnabled === "Y") ||
          (fundData.purchaseAmount === null &&
            selectedSchemeData?.purchaseValidation.webPurchaseEnabled === "Y")
        ) {
          setShowAddButton({
            type: fundData.sipAmount === null ? "SIP" : "Purchase",
            show: true,
          });
        }
        if (fundData.sipOpted == true) {
          let omm =
            selectedSchemeData &&
            selectedSchemeData.sipValidation &&
            selectedSchemeData.sipValidation.additionalValidation &&
            selectedSchemeData.sipValidation.additionalValidation.OM &&
            selectedSchemeData.sipValidation.additionalValidation.OM.length >
            0 &&
            selectedSchemeData.sipValidation.additionalValidation.OM;
          let defaultAmount = fundData.sipAmount;
          if (omm != undefined && omm.length > 0) {
            let filteredObj = omm.find((obj, index) => {
              if (
                obj.min_amount_lower <= defaultAmount &&
                obj.min_amount_upper >= defaultAmount
              ) {
                return obj;
              } else if (
                obj.min_amount_upper == undefined &&
                obj.min_amount_lower <= defaultAmount
              ) {
                return obj;
              }
            });
            if (filteredObj != undefined) {
              setTransactionMonth(filteredObj.min_installments);
            }
          }
        }
        if (fundData.cancellationIsChecked) {
          setfirstLoad(false);
        }
      } else {
        setTransactionDetails(isJanNivesh ? {...selectedSchemeData, purchaseValidation: null } : selectedSchemeData);

        let om =
          selectedSchemeData &&
          selectedSchemeData.sipValidation &&
          selectedSchemeData.sipValidation.additionalValidation &&
          selectedSchemeData.sipValidation.additionalValidation.OM &&
          selectedSchemeData.sipValidation.additionalValidation.OM.length > 0 &&
          selectedSchemeData.sipValidation.additionalValidation.OM;
        let defaultAmount =
          selectedSchemeData &&
          selectedSchemeData.sipValidation &&
          selectedSchemeData.sipValidation.sipDefaultAmount;
        if (om != undefined && om.length > 0) {
          let filteredObj = om.find((obj, index) => {
            if (
              obj.min_amount_lower <= defaultAmount &&
              obj.min_amount_upper >= defaultAmount
            ) {
              return obj;
            } else if (
              obj.min_amount_upper == undefined &&
              obj.min_amount_lower <= defaultAmount
            ) {
              return obj;
            }
          });
          if (filteredObj != undefined) {
            setTransactionMonth(filteredObj.min_installments);
          }
        }
      }
      // setTransactionMonth(selectedSchemeData.sipValidation && selectedSchemeData.sipValidation.monMinInstallmentNumber);

      setFundDetailsData((prev) => ({
        ...prev,
        cgfApplicable: selectedSchemeData?.cgfApplicable,
        retirementApplicable: selectedSchemeData?.retirementApplicable,
      }));

      const janNiveshData = eCart && eCart.fundDetails && eCart.fundDetails.data && eCart.fundDetails.data.janNiveshRules
      setJanNiveshRuleData(janNiveshData);
      if(isJanNivesh){
        setStartDate(moment(moment(), "MM-DD-YYYY").add(janNiveshData && janNiveshData.sipTDay, "days"));
      }else{
        setStartDate(
          fundData.sipDate
            ? moment(moment(fundData.sipDate), "MM-DD-YYYY")
            : moment(moment(), "MM-DD-YYYY").add(
              selectedSchemeData?.sipValidation?.sipTDay,
              "days"
            )
        );
      }

      cancellationIsChecked &&
        setEndDate(
          fundData.toDate
            ? moment(moment(fundData.toDate), "MM-DD-YYYY")
            : moment(moment(), "MM-DD-YYYY")
              .add(selectedSchemeData?.sipValidation?.sipTDay, "days")
              .set("year", 2099)
        );

      setCancellationIsChecked(
        fundData.cancellationIsChecked != undefined
          ? fundData.cancellationIsChecked
          : false
      );

    }
  }, [eCart.fundDetails.data]);

  const getSelectedSchemeData = (allSchemes, code) => {
    let selectedScheme = allSchemes?.filter((ele) => {
      return ele.schemeCode === code;
    });

    return selectedScheme?.length ? selectedScheme[0] : null;
  };

  const fetchFundDetails = async (response) => {
    let code = fundData?.fundCode;
    let schemeCode = fundData?.scheme?.code;

    let isDirectOrRegular =
      schemeCode &&
      checkIsDirectOrRegular(response.data.funds, code, schemeCode);
    let data = {
      fundCode: code,
      // directFund: isDirectOrRegular
      //   ? isDirectOrRegular.isDirect
      //     ? true
      //     : false
      //   : true,
    };

    if (fundData?.isDirect || isDirectOrRegular?.isDirect) {
      data["directFund"] = true;
    } else if (fundData?.isRegular || isDirectOrRegular?.isRegular) {
      data["directFund"] = false;
    } else {
      let cartData = cookie.load("CartDetails") || {};
      if (Object.values(cartData).length > 0)
        data["directFund"] = Object.values(cartData)[0].isDirect;
      else data["directFund"] = true;
    }
    await getFundDetails(data);
  };

  const getSchemeListName = () => {
    return schemeList.filter(
      (scheme) => scheme.code == selectedScheme?.code
    )?.[0]?.name;
  };

  const onDropdownValueSelect = (val) => {
        let data = eCart.fundDetails.data && eCart.fundDetails.data.schemeDetails;
        data.map((ele) => {
      if (ele.schemeName === val) {
        setSelectedScheme({ name: val, code: ele.schemeCode, monMax: ele.sipValidation.monMaxInstallmentNumber });
        setTransactionDetails(ele);
                 
        setAmount({
          sipAmount:
            ele.sipValidation?.sipEnabled === "Y" && amount.sipAmount!=null ? amount.sipAmount : ele.sipValidation.sipDefaultAmount,
          purchaseAmount:
            ele.purchaseValidation?.webPurchaseEnabled === "Y" && amount.purchaseAmount!=null
              ? amount.purchaseAmount
              : ele.purchaseValidation.defaultAmount,
        });

        // setStartDate(
        //   moment(moment(), "MM-DD-YYYY").add(ele.sipValidation?.sipTDay, "days")
        // );
        // setEndDate(
        //   moment(moment(startDate), "MM-DD-YYYY")
        //     // .add(6, "M")
        //     .set("year", 2099)
        // );

        setEndDate( moment(moment(startDate), "MM-DD-YYYY").add(addYearDate, "years").subtract(1, "M"));
        
        setCancellationIsChecked(false);

        setSchemeIsDividend(ele.investmentOption === "DIVIDEND");
        let options = [];
        if (ele.investmentOption === "GROWTH") {
          options = [];
          setdividendOptionValue("Growth");
        }

        if (
          ele.investmentOption === "DIVIDEND" &&
          ele.dividendReinvestmentApplicable
        ) {
          setdividendOptionValue("Re-investment");
        } else if (
          ele.investmentOption === "DIVIDEND" &&
          ele.dividendPayoutApplicable
        ) {
          setdividendOptionValue("Payout");
        }

        ele.dividendReinvestmentApplicable &&
          options.push({ name: "Re-investment" });
        ele.dividendPayoutApplicable && options.push({ name: "Payout" });
        setIDCWOptions(options);
        setPreLoginData(eCart.allSchemeDetails.data.funds, ele.schemeCode);
      }
    });
    // setError({
    //   sipError: "",
    //   purchaseError: "",
    // });
    setShowAddButton({
      type: "",
      show: false,
    });
  };

  const checkIsCGF = () => {
    let cartDetailCookie = InvestNow == "Invest Now" ? cookie.load("ProceedCartDetails") || {} : cookie.load("CartDetails") || {};
    if (Object.values(cartDetailCookie).length > 0) {
      let result = Object.values(cartDetailCookie).filter((ele) => {
        if (ele.cgfApplicable) {
          return ele;
        }
      });

      if (result.length > 0) return true;
      else return false;
    }
  };

  const checkIsRetirement = () => {
    let cartDetailCookie = InvestNow == "Invest Now" ? cookie.load("ProceedCartDetails") || {} : cookie.load("CartDetails") || {};
    if (Object.values(cartDetailCookie).length > 0) {
      let result = Object.values(cartDetailCookie).filter((ele) => {
        if (ele.retirementApplicable) {
          return ele;
        }
      });

      if (result.length > 0) return true;
      else return false;
    }
  };

  useEffect(() => {
    if (IDCWOptions.length === 0) {
      setSelectedIDCW({});
    }
    IDCWOptions?.length > 0 &&
      setSelectedIDCW({
        name:
          fundData?.isEditFlow && fundData.idcwOptions.length > 0
            ? fundData?.selectedIDCW?.name
            : IDCWOptions[0].name,
      });
  }, [IDCWOptions]);

  const onIDCWSelect = (val) => {
    setSelectedIDCW({ name: val });
    setdividendOptionValue(val);
  };

  const setPreLoginData = (allFunds, schemeCode) => {
    allFunds &&
      allFunds.forEach((fund) => {
        if (fund.fundCode === fundData.fundCode) {
          let directSchemes = fund.directScheme;
          let regularSchemes = fund.regularScheme;

          let directSchemeResult = directSchemes?.filter((scheme) => {
            return scheme.schemeCode === schemeCode;
          });

          if (directSchemeResult.length === 0) {
            let regularSchemeResult = regularSchemes?.filter((scheme) => {
              return scheme.schemeCode === schemeCode;
            });
            setFundDetailsData((prev) => ({
              ...prev,
              liquid:
                regularSchemeResult[0]?.schemeType === "LIQUID" ? true : false,
            }));
          } else {
            setFundDetailsData((prev) => ({
              ...prev,
              liquid:
                directSchemeResult[0]?.schemeType === "LIQUID" ? true : false,
            }));
          }
        }
      });
  };

  const checkIsDirectOrRegular = (allFunds, fundCode, schemeCode) => {
    let result = {
      isDirect: false,
      isRegular: false,
    };
    allFunds.forEach((fund) => {
      if (fund.fundCode === fundCode) {
        let directSchemes = fund.directScheme;
        let regularSchemes = fund.regularScheme;

        let directSchemeResult = directSchemes?.filter((scheme) => {
          return scheme.schemeCode === schemeCode;
        });

        let regularSchemeResult = regularSchemes?.filter((scheme) => {
          return scheme.schemeCode === schemeCode;
        });
        result = {
          isDirect: directSchemeResult.length !== 0,
          isRegular: regularSchemeResult.length != 0,
        };
      }
    });

    return result;
  };

  useEffect(() => {
    if (!fundData.isEditFlow) {
      if (!cancellationIsChecked) {
        if(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax !== undefined){
          setEndDate(
            moment(moment(startDate), "MM-DD-YYYY")
              .add(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax, "M")
          );
        }
        else if (!clear) {
          setEndDate( moment(moment(startDate), "MM-DD-YYYY").add(addYearDate, "years").subtract(1, "M")
            // moment(moment(startDate), "MM-DD-YYYY").add(transactionMonth, "M")
          );
        }
        setemandateTxt(false);
        // setEndDateErr(true);
      }
  
      if (cancellationIsChecked) {
        if(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax !== undefined){
          setEndDate(
            moment(moment(startDate), "MM-DD-YYYY")
              .add(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax, "M")
          );
        }
        else {
          setEndDate(
            moment(moment(startDate), "MM-DD-YYYY")
              // .add(6, "M")
              .set("year", 2099)
          );
        }
        setEndDateErr(false);
        setemandateTxt(true);
      }
    } else if (fundData.isEditFlow) {
      if (!cancellationIsChecked) {

        if(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax !== undefined){
        }else if (fundData.toDate && firstLoad) {
          setEndDate(moment(moment(fundData.toDate), "MM-DD-YYYY"));
          setfirstLoad(false);
          setsecondLoad(true);
        } else if (secondLoad 
          // || (!secondLoad && filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax == undefined)
          ) {
          setEndDate(moment(moment(fundData.toDate), "MM-DD-YYYY"));
          setsecondLoad(true);
        }
        else if (!clear) {
          setEndDate( moment(moment(startDate), "MM-DD-YYYY").add(addYearDate, "years").subtract(1, "M")
            // moment(moment(startDate), "MM-DD-YYYY").add(transactionMonth, "M")
          );
        }
        // else {
        //   setEndDate();
        //   setEndDateErr(true);
        // }
        setemandateTxt(false);
      }
  
      if (cancellationIsChecked) {
        if(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax !== undefined){
          setEndDate(
            moment(moment(startDate), "MM-DD-YYYY")
              .add(filterMonMaxInstallmentNumber && filterMonMaxInstallmentNumber.monMax, "M")
          );
        }
        else {
          setEndDate(
            moment(moment(startDate), "MM-DD-YYYY")
              // .add(6, "M")
              .set("year", 2099)
          );
        }
        setemandateTxt(true);
        setsecondLoad(false);
        setEndDateErr(false);
      }
    }
  }, [cancellationIsChecked, transactionMonth, filterMonMaxInstallmentNumber]);  

  useEffect(() => {
    setFundDetailsData((prev) => ({
      ...prev,
      dividendOption:
        dividendOptionValue === "Growth"
          ? "Z"
          : dividendOptionValue === "Re-investment"
            ? "Y"
            : "N",
    }));
  }, [dividendOptionValue]);


  const onFundsClick = () => {
    setCartJourneyPage(1);
  };
  const onAddFundsClick = () => {
    setCartJourneyPage(2);
  };
  return ( 
    <>
      <div className="cart-details-screen">
        <div className="carddetailsDiv">
          {/* <img
            src="/images/closeCircle.svg"
            onClick={closePopup}
            className="closeIcon"
          ></img> */}
          <h4 className="title">{InvestNow !== "Invest Now" ? "Add to Cart" : "Investment Details"}</h4>
          <svg width="35" height="35" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>{
            InvestNow == "Invest Now" ? closePopup() : onFundsClick()
          }}>
            {/* <path d="M25.5492 47.6663C37.2593 47.6663 46.8402 37.9163 46.8402 25.9997C46.8402 14.083 37.2593 4.33301 25.5492 4.33301C13.8392 4.33301 4.2583 14.083 4.2583 25.9997C4.2583 37.9163 13.8392 47.6663 25.5492 47.6663Z" fill="#E4E4E4" /> */}
            <path d="M19.5239 32.1315L31.5746 19.8682" stroke="rgba(0, 0, 0, 1)" stroke-width="3.0" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M31.5746 32.1315L19.5239 19.8682" stroke="rgba(0, 0, 0, 1)" stroke-width="3.0" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div className="paddingdiv">
          <div>
            <div className="belowtitle">
              <p>You have added below funds(s):</p>
            </div>
            <p className="fundName">You're investing in {fundData?.fundName}</p>
            {isJanNivesh ? (
            <div className="janniveshdiv">
              <p>{getSchemeListName()}</p>
            </div>
            ) : (
              <>
                {schemeList?.length === 0 && (
                  <div className="no-schemes">No Schemes available</div>
                )}
                {schemeList?.length > 0 && (
                  <div className="plan-dropdown">
                    <p>Select a Plan Option</p>
                    <Dropdown
                      dropdownOptions={schemeList}
                      defaultSelected={getSchemeListName()}
                      fromECartJourney={true}
                      onSelect={(val) => onDropdownValueSelect(val)}
                      isAutocapital={false}
                    ></Dropdown>
                  </div>
                )}
                {schemIsDividend && (
                  <div className="idcw-dropdown">
                    <p>Select IDCW Option</p>
                    <Dropdown
                      fromECartJourney={true}
                      dropdownOptions={IDCWOptions}
                      defaultSelected={selectedIDCW?.name}
                      onSelect={(val) => onIDCWSelect(val)}
                    ></Dropdown>
                  </div>
                )}
              </>
            )}
          </div>

          {transactionDetails?.purchaseValidation &&
            transactionDetails.purchaseValidation.webPurchaseEnabled === "Y" && (
              <TransactionCard
                isPurchase={true}
                onRemoveClick={() => onRemoveClick("Purchase")}
                isJanNivesh={isJanNivesh}
                onAmountChange={(name, val) => onAmountChange(val, "Purchase")}
                isDisabled={
                  transactionDetails.sipValidation?.sipEnabled === "N" ||
                  !transactionDetails.sipValidation
                }
                amount={amount.purchaseAmount}
                error={error.purchaseError}
                amountArray={
                  transactionDetails.purchaseValidation.amountArray || []
                }
                maxLength={15}
                transactionDetailCards={transactionDetails}
                accordindex={0}
              ></TransactionCard>
            )}

          {transactionDetails?.sipValidation &&
            transactionDetails.sipValidation.sipEnabled === "Y" && (
              <TransactionCard
                isSip={true}
                isJanNivesh={isJanNivesh}
                janNiveshRuleData={janNiveshRuleData}
                onRemoveClick={() => onRemoveClick("Sip")}
                onAmountChange={(name, val) => onAmountChange(val, "Sip")}
                isDisabled={
                  transactionDetails.purchaseValidation?.webPurchaseEnabled ===
                  "N" || !transactionDetails.purchaseValidation
                }
                amount={amount.sipAmount}
                error={error.sipError}
                amountArray={transactionDetails.sipValidation.amountArray || []}
                onChange={onChange}
                startDate={startDate}
                endDate={endDate}
                setCancellationIsChecked={setCancellationIsChecked}
                cancellationIsChecked={cancellationIsChecked}
                sipTDate={sipTDate}
                transactionMonth={transactionMonth}
                maxLength={12}
                transactionDetailCards={transactionDetails}
                emandateText={emandateTxt}
                filterMonMaxInstallmentNumber={filterMonMaxInstallmentNumber}
                setClear={setClear}
                accordindex={1}
              ></TransactionCard>
            )}
          {showAddButton.show && (
            <button
              className="add-sip-purchase"
              onClick={() => addSipPurchase(showAddButton.type)}
            >
              {/* <img src="/images/addCircle.svg"></img> */}
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="20" fill="#F3F9FF" />
                <path d="M19.9058 11.4287L19.9058 19.6706L19.9058 27.9122" stroke="#D83731" stroke-width="1.92308" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M28.1499 19.6709L19.908 19.6709L11.6664 19.6709" stroke="#D83731" stroke-width="1.92308" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              {`Add ${showAddButton.type === "Purchase" ? "Purchase" : "SIP"
                } Transaction`}
            </button>
          )}
          {InvestNow !== "Invest Now" ? <div className="addMoreFund" onClick={onAddFundsClick}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="20" fill="#EFEFFF" />
              <path d="M19.9058 11.4287L19.9058 19.6706L19.9058 27.9122" stroke="#6C6CFF" stroke-width="1.92308" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M28.1499 19.6709L19.908 19.6709L11.6664 19.6709" stroke="#6C6CFF" stroke-width="1.92308" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div>
              <p>Add More Funds</p>
              <p>You can add maximum three items to the cart.</p>
            </div>
          </div> : ''}
          {InvestNow !== "Invest Now" ?
            <>
            {endDateErr && <button
              className={`addToCart ${(error.sipError || error.purchaseError) && "disabled"
                }`}
              onClick={error.sipError || error.purchaseError ? null : onAddToCart}
              disabled={endDateErr}
            >
              {fundData.isEditFlow ? "Save" : "Add to Cart"}
            </button>}

            {endDateErr == false && <button
              className={`addToCart ${(error.sipError || error.purchaseError) && "disabled"
                }`}
              onClick={error.sipError || error.purchaseError ? null : onAddToCart}
              disabled={
                showError?.show ||
                (transactionDetails?.purchaseValidation?.webPurchaseEnabled === "N" &&
                  transactionDetails?.sipValidation?.sipEnabled === "N") ||
                schemeList.length === 0 || endDate == undefined
              }
            >
              {fundData.isEditFlow ? "Save" : "Add to Cart"}
            </button>}
            </>
          :
            <>
            {endDateErr && <button
              className={`addToCart ${(error.sipError || error.purchaseError) && "disabled"
                }`}
              onClick={error.sipError || error.purchaseError ? null : onInvestCart}
              disabled={endDateErr}
            >
              {fundData.isEditFlow ? "Save" : "Proceed to Pay"}
            </button>}

            {endDateErr == false && <button
              className={`addToCart ${(error.sipError || error.purchaseError) && "disabled"
                }`}
              onClick={error.sipError || error.purchaseError ? null : onInvestCart}
              disabled={
                showError?.show ||
                (transactionDetails?.purchaseValidation?.webPurchaseEnabled === "N" &&
                  transactionDetails?.sipValidation?.sipEnabled === "N") ||
                schemeList.length === 0 || endDate == undefined
              }
            >
              {fundData.isEditFlow ? "Save" : "Proceed to Pay"}
            </button>}
            </>
          }
          {showError.show && (
            <div className="error">
              {showError.show && (
                <p>
                  {showError.type === "cgf"
                    ? ""
                    : showError.type === "maxLimit"
                      ? ""
                      : showError.type === "directRegular"
                        ? ""
                        : "Something went wrong !"}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
      {/* {popupData && (<div className="alertModal">
        <div className="popupOuter">
          <div className="popupSec">
            <div className="heading">
              <p>Alert</p>
              <svg width="35" height="35" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"  onClick={handlepopupClose} className="cursorp">
                <path d="M19.5239 32.1315L31.5746 19.8682" stroke="#3A3A3A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M31.5746 32.1315L19.5239 19.8682" stroke="#3A3A3A" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div className="maindiv">
              <p className="stepaway">Your are one step away from investing!</p>
              <p className="leave">Are your sure you want to leave the investment?</p>
              <div className="buttondiv">
                <button className="yesbtn" onClick={closePopup}>Yes, leave</button>
                <button className="addcartbtn" onClick={handlepopupClose}>Add to cart</button>
              </div>
            </div>
          </div>
        </div>
        <div className="popup_overlay black_overlay" />
        </div>
      )} */}
    </>
  );
};

const mapStateToProps = (state) => ({
  eCart: state.eCart,
});

const mapDispatchToProps = (dispatch) => ({
  openPopup: bindActionCreators(openPopup, dispatch),
  closePopup: bindActionCreators(closePopup, dispatch),
  getFundDetails: bindActionCreators(getFundDetails, dispatch),
  getAllSchemeDetails: bindActionCreators(getAllSchemeDetails, dispatch),
  updateEcartDetails: bindActionCreators(updateEcartDetails, dispatch),
  saveKycDataEcart: bindActionCreators(saveKycDataEcart, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartDetails);
